import React from "react";
import { Box, Chip, Paper, Stack, Typography, Skeleton } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

const formatDateTime = (value) => {
  if (!value) return "Not available";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Not available";
   const updatedDate = new Date(
    date.getTime() + ((5 * 60 + 30) * 60 * 1000)
  );

  return updatedDate.toLocaleString();
};

const getStatusUi = (status) => {
  if (status === "up_to_date") {
    return {
      label: "Up To Date",
      color: "#047857",
      bg: "rgba(16,185,129,0.12)",
    };
  }

  if (status === "attention") {
    return {
      label: "Needs Attention",
      color: "#B45309",
      bg: "rgba(245,158,11,0.16)",
    };
  }

  return {
    label: "Unknown",
    color: "#475569",
    bg: "rgba(148,163,184,0.18)",
  };
};

function OverviewRow({ label, value, loading }) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 2,
        py: 1.25,
        borderBottom: "1px solid rgba(226,232,240,0.7)",
      }}
    >
      <Typography sx={{ color: "#475569", fontWeight: 700, fontSize: 13 }}>
        {label}
      </Typography>
      {loading ? (
        <Skeleton width={160} height={22} />
      ) : (
        <Typography sx={{ color: "#0F172A", fontWeight: 700, fontSize: 14 }}>
          {value || "--"}
        </Typography>
      )}
    </Box>
  );
}

export default function FirmwareOverview({ overview, loading = false }) {
  const statusUi = getStatusUi(overview?.status);

  return (
    <Paper
      elevation={0}
      sx={{
        border: "1px solid rgba(226,232,240,0.95)",
        borderRadius: 4,
        p: { xs: 2, md: 2.5 },
        background: "linear-gradient(180deg, #FFFFFF, #F8FAFC)",
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1.25}>
        <Typography sx={{ fontWeight: 800, color: "#0F172A", fontSize: 16 }}>
          Firmware Snapshot
        </Typography>
        {loading ? (
          <Skeleton width={110} height={30} />
        ) : (
          <Chip
            icon={<FiberManualRecordIcon sx={{ fontSize: 11 }} />}
            label={statusUi.label}
            sx={{
              color: statusUi.color,
              backgroundColor: statusUi.bg,
              fontWeight: 700,
            }}
          />
        )}
      </Stack>

      <OverviewRow label="Current Version" value={overview?.version || "--"} loading={loading} />
      <OverviewRow
        label="Last Update Time"
        value={formatDateTime(overview?.last_updated_at)}
        loading={loading}
      />
      <Box sx={{ pt: 1.25 }}>
        <OverviewRow label="Update Method" value={overview?.update_method || "OTA"} loading={loading} />
      </Box>
    </Paper>
  );
}
